import React from "react"

const RequiredMark: React.FC<{
  visible?: boolean
}> = ({ visible = true }) => {
  return <span className={"required-mark" + (visible ? "" : " display_none")}>*</span>
}

export default RequiredMark
